import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';

import { HpmsCustomCardApi } from '@philips-emr/hpms-provider-components';
import { DeckAPI, FetchAPI, Token } from '@philips-emr/tws-components';
import { Type } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnDynamicContentRender, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';
import { LocaleService } from '@philips-emr/tws-core/lib/services';

import { MessagesSummaryAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { Message, Status } from './messages-controller';

import './messages-summary-controller.css';

@Controller({ fragment: FragmentNames.MESSAGES_SUMMARY })
class MessagesSummaryController extends BaseController {

  @Inject (Aliases.DECK_MESSAGES)
  private deckMessages: DeckAPI;
  @Inject(Aliases.FETCH_MESSAGES)
  private fetchMessages: FetchAPI;

  @OnAfterFetch(Aliases.FETCH_MESSAGES)
  onAfterFetchMessages(event: FetchEvent): void {
    if (event.data) {
      const messages = event.data as Message[];
      const messagesFormattedData = messages.map((data) => {
        const formattedDate = new Date(data.dtRelease);
        return {
          ...data,
          dtRelease: formattedDate.toLocaleDateString( LocaleService.getCurrentLocale() ),
        };
      });

      this.fetchMessages.setState({ data: messagesFormattedData });

      this.deckMessages.setDone(true);
    }
  }

  @OnMount(Aliases.HPMS_CUSTOM_CARD_MESSAGES)
  onMountHpmsCustomCardMessages(event: MountEvent): void {
    const api = event.target as HpmsCustomCardApi;
    const data = api.state;
    const { ieRead } = data as unknown as { ieRead: string };
    if (ieRead !== Status.YES) {
      api.setBackground('hsl(var(--color-5))');
    }
  }

  @OnDynamicContentRender(Aliases.HPMS_CUSTOM_CARD_MESSAGES)
  onDynamicContentRenderCustomCardMessages(event: RenderEvent): void {
    const { data, render } = event;
    const { ieRead } = data as Message;
    let wasReadToken: ReactElement = <></>;

    if (ieRead !== Status.YES) {
      wasReadToken = <Token type={Type.NOTICE} value={''} />;
    }

    render(() => <>
      { wasReadToken }
    </>);
  }
}

export {
  MessagesSummaryController,
};
